export default "__VITE_ASSET__CWjNaRKt__"